module.exports = __webpack_public_path__ + "img/hook_KITO_HTL_4.72ee4451.png";